import React, { useContext,  useState } from "react";
import { IoIosCloseCircleOutline } from "react-icons/io";
import bank from "../assets/images/bank.png";
import upi from "../assets/images/upi.jpg";
import { toast } from "react-toastify";
import styles from "../styles/Profile/BasicProfile.module.css";
import authContext from "../context/auth/authContext";
const WithdrawModal = ({ close }) => {
  const [checkbox1, setCheckbox1] = useState(false);
  const [checkbox2, setCheckbox2] = useState(false);
  const [proceed, setProceed] = useState(false);
  const [name, setName] = useState("");
  const [account, setAccount] = useState("");
  const [IFSC, setIFSC] = useState("");
  const [vpa, setVpa] = useState("");
  const { addBDetails } = useContext(authContext);
  const handleProceed = () => {
    if (proceed) {
      if (checkbox1) {
        if (name === "" || account === "" || account === "" || IFSC === "") {
          toast.error("Fields cannot be empty!!!", { autoClose: 6000 });
        } else {
          addBDetails({
            type: "bank_account",
            vpa: null,
            bankDetails: {
              name,
              ifsc: IFSC,
              account_number: account,
            },
          });
        }
      }
      if (checkbox2) {
        if (vpa === "") {
          toast.error("Fields cannot be empty!!!", { autoClose: 6000 });
        } else {
          addBDetails({
            type: "vpa",
            vpa,
            bankDetails: {},
          });
        }
      }
    } else {
      if (checkbox1 || checkbox2) {
        setProceed(true);
      } else {
        toast.error("Please choose an option", { autoClose: 6000 });
      }
    }
  };

  return (
    <div className="Register">
      <div className="Login__container">
        <div style={{ textAlign: "right" }}>
          <IoIosCloseCircleOutline
            size={40}
            style={{ cursor: "pointer" }}
            onClick={close}
          />
        </div>
        <div className="Register__content">
          <p>Choose an option</p>

          {proceed ? (
            checkbox1 ? (
              <section className="Register__details">
                <h3>Add Bank Details</h3>
                <div className={styles.Profile__right}>
                  <div className="Register__form" style={{ textAlign: "left" }}>
                    <p>Name on Bank Account</p>
                    <input
                      type="text"
                      placeholder="&#xF007;&nbsp; Enter your name"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                    />
                    <p>Account Number</p>
                    <input
                      type="text"
                      placeholder="&#xF007;&nbsp; Enter your Account Number"
                      value={account}
                      onChange={(e) => setAccount(e.target.value)}
                    />
                    <p>IFSC code</p>
                    <input
                      type="text"
                      placeholder="&#xF007;&nbsp; Enter Bank's IFSC code"
                      value={IFSC}
                      onChange={(e) => setIFSC(e.target.value)}
                    />
                  </div>
                </div>
              </section>
            ) : checkbox2 ? (
              <section className="Register__details">
                <h3>Add UPI Details</h3>

                <div className={styles.Profile__right}>
                  <div className="Register__form" style={{ textAlign: "left" }}>
                    <p>UPI id</p>
                    <input
                      type="text"
                      placeholder="&#xF007;&nbsp; Enter your UPI"
                      value={vpa}
                      onChange={(e) => setVpa(e.target.value)}
                    />
                  </div>
                </div>
              </section>
            ) : (
              <></>
            )
          ) : (
            <section className="Register__details">
              <div className="Register__bank">
                <input
                  type="checkbox"
                  checked={checkbox1}
                  onChange={(e) => {
                    setCheckbox1(e.target.checked);
                    setCheckbox2(e.target.checked && false);
                  }}
                />
                <img src={bank} alt="bank_img" />
                <p>Add Bank Details</p>
              </div>

              <div className="Register__upi">
                <input
                  type="checkbox"
                  checked={checkbox2}
                  onChange={(e) => {
                    setCheckbox2(e.target.checked);
                    setCheckbox1(e.target.checked && false);
                  }}
                />
                <img src={upi} alt="upi_img" />
                <p>Add UPI Details</p>
              </div>
            </section>
          )}
        </div>

        <div className="Register__social" style={{ marginTop: "10px" }}>
          <button
            className="Register__button"
            onClick={() => (proceed ? setProceed(false) : close)}
            style={{
              marginRight: "10px",
              width: "100px",
              borderRadius: "5px",
              background: "#EFF2F5",
              color: "#000",
            }}
          >
            {proceed ? "BACK" : "CANCEL"}
          </button>
          <button
            className="Register__button"
            onClick={() => {
              handleProceed();
              proceed && close();
            }}
            style={{
              marginRight: "10px",
              width: "120px",
              borderRadius: "5px",
            }}
          >
            PROCEED
          </button>
        </div>
      </div>
    </div>
  );
};

export default WithdrawModal;
